import React from 'react';
import { WhamProjectionSlider } from '../common/SliderControls/SliderControls';
import type { RegistryComponentProps } from '../../pages/registry/componentRegistry';
import { getRegistryData } from '../../pages/registry/componentRegistry';
import { useFormContextOptional } from '../../contexts/FormContext';

const SLUG = 'projection-mortality-strategy';

interface ProjectionMortalityStrategyData {
  oflValues?: number[];
  projectionYears?: number[];
  disabled?: boolean;
}

export default function ProjectionMortalityStrategy(props: RegistryComponentProps): React.ReactElement {
  const formContext = useFormContextOptional();
  const data = getRegistryData<ProjectionMortalityStrategyData>(props);

  const oflValues: number[] = data.oflValues ?? [];
  const projectionYears: number[] = data.projectionYears ?? [];
  const disabled = data.disabled ?? false;

  const setValue = formContext?.setValue;
  const handleChange = React.useCallback(
    (config: Record<string, unknown>) => {
      setValue?.(SLUG, config);
    },
    [setValue]
  );

  return (
    <WhamProjectionSlider
      oflValues={oflValues as unknown as never[]}
      projectionYears={projectionYears as unknown as never[]}
      onChange={handleChange}
      disabled={disabled}
    />
  );
}
